import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { HOME_PATH } from "../../../../apps/values/path";
import { map, take } from 'rxjs/operators';
import { Observable } from 'rxjs';

export const NotLoggedInGuard: CanActivateFn = (route, state): Observable<boolean> => {
  const auth = inject(AuthService);
  const router = inject(Router);

  return auth.isAuthenticated$.pipe(
    take(1),
    map(isAuthenticated => {
      if (isAuthenticated) {
        const HOME_ROUTE_PATH = `/${HOME_PATH}`;
        router.navigate([HOME_ROUTE_PATH]);
        return false;
      }
      return true;
    })
  );
};

